export enum AdminPanelActionTypes {
    API_RESPONSE_SUCCESS = '@@adminPanel/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@adminPanel/API_RESPONSE_ERROR',

    ADMIN_CLEAR_CACHE = '@@adminPanel/ADMIN_CLEAR_CACHE',
}
